import React from 'react';


export default function Steps(props) {
  return (
    <div className="checkout-steps row">
      <div className={props.step1 ? 'active col' : 'col'}>Anmeldung</div>
      <div className={props.step2 ? 'active col' : 'col'}>Versand</div>
      <div className={props.step3 ? 'active col' : 'col'}>Bezahlung</div>
      <div className={props.step4 ? 'active col' : 'col'}>Bestellung aufgeben</div>
    </div>
  );
}